import { Component, computed, inject } from '@angular/core';
import { ActivityLog } from '../../../../../Models/avyna/activity-log.model';
import { AvContentContainerComponent } from '../../../../Shared/Components/av-content-container/av-content-container.component';
import { AvTableCard } from '../../../../Shared/Components/av-table-card/av-table-card.component';
import { AvTableColumn, AvTableCopyCell, AvTableRow } from '../../../../Shared/Interfaces/av-table-card.interface';
import { ShowDeviceFacade } from '../../../../../Facades/Intune/show-device.facade';
import { formatDate } from '../../../../Shared/Utils/date.utils';

@Component({
  selector: 'app-activity-log',
  standalone: true,
  imports: [AvContentContainerComponent, AvTableCard],
  templateUrl: './activity-log.component.html',
  styleUrls: ['./activity-log.component.scss'],
})
export class ActivityLogComponent {
  private readonly _facade = inject(ShowDeviceFacade);

  readonly device = this._facade.device;

  readonly columns: AvTableColumn[] = [
    { key: 'action', label: 'app.device.activity_log.columns.action', sortable: true },
    { key: 'user', label: 'app.device.activity_log.columns.user', sortable: true },
    { key: 'email', label: 'app.device.activity_log.columns.email', type: 'copy', sortable: true },
    { key: 'created_at', label: 'app.device.activity_log.columns.created_at', sortable: true },
  ];

  readonly rows = computed<AvTableRow[]>(() => {
    const logs = this.device()?.activityLog;
    if (!Array.isArray(logs)) return [];

    return logs.map((log: ActivityLog) => ({
      action: log.action ? `app.device.activity_log.actions.${log.action}` : null,
      user: log.user?.displayName ?? null,
      email: { content: log.user?.displayEmail() } as AvTableCopyCell,
      created_at: formatDate(log.created_at) ?? null,
    }));
  }); 

}
